import axiosClient, { responseBody } from '@/api/axios-client';
import {
  SignupValuesType,
  LoginValuesType,
  ForgotPasswordValuesType,
  ResetPasswordValuesType,
} from '@/framework/user';

/**
 * Cookie / SPA
 * Cross site requests
 * Confirming that all the request coming from the app
 */
export const setupXSRF = () => {
  axiosClient.get('/sanctum/csrf-cookie').catch(() => {
    // Dev server may be up before Laravel; App retries via later API calls.
  });
};

export const login = (values: LoginValuesType) => {
  const { email, password } = values;
  return axiosClient
    .post('/api/auth/login', {
      email,
      password,
    })
    .then(responseBody);
};

export const signup = (values: SignupValuesType) => {
  const { username, email, password } = values;
  return axiosClient
    .post('/api/auth/register', {
      ...(username ? { username } : {}),
      email,
      password,
      password_confirmation: password,
    })
    .then(responseBody);
};

export const createGuest = () =>
  axiosClient.post('/api/auth/guest').then(responseBody);

export const logout = () => {
  return axiosClient.post('/api/auth/logout').then(responseBody);
};

export const resendVerification = () => {
  return axiosClient
    .post('/api/email/verification-notification')
    .then(responseBody);
};

export const forgotPassword = (values: ForgotPasswordValuesType) => {
  const { email } = values;

  return axiosClient.post('/api/forgot-password', {
    email,
  });
};

export const resetPassword = (values: ResetPasswordValuesType) => {
  const { email, resetToken, password, passwordConfirmation } = values;

  return axiosClient.post('/api/reset-password', {
    email,
    token: resetToken,
    password,
    password_confirmation: passwordConfirmation,
  });
};
